import type { CSSProperties } from 'react';
import '../components/atomic/layout/app_screen/app_screen.css';
import { containFitScale } from '../../../infrastructure/runtime';
import { useAppFit } from '../../hooks/useAppFit';
import { Shine } from '../components/atomic/atmosphere/shine/Shine';
import { GoHomeButton } from '../components/atomic/buttons/go_home_button/GoHomeButton';
import { RestartButton } from '../components/atomic/buttons/restart_button/RestartButton';
import type { FailDeliveryScreenModel } from './FailDeliveryScreenModelScreen';
import { CharacterIcon } from './character_icon/CharacterIcon';
import { FailDeliveryClouds } from './clouds/FailDeliveryClouds';
import { FailDeliveryHeader } from './header/FailDeliveryHeader';
import { PlaqueSmallBad } from './plaque_small_bad/PlaqueSmallBad';
import type { FailDeliveryScreenController } from './FailDeliveryScreenController';
import './fail_delivery_screen.css';
import type { ScreenViewProps } from '../shared/screenViewProps';

export type FailDeliveryScreenViewProps = ScreenViewProps<
  FailDeliveryScreenModel,
  FailDeliveryScreenController
>;

/** Failed delivery screen stub (Figma game over screen 142:17524). */
export function FailDeliveryScreenView({
  model,
  controller,
}: FailDeliveryScreenViewProps) {
  const fit = useAppFit();
  const contain = containFitScale(fit.scale);

  return (
    <div className="app-screen fail-delivery-screen">
      <FailDeliveryClouds />
      <Shine variant="delivery" />
      <div
        className="fail-delivery-plaques"
        style={
          {
            '--fit-contain-inv-x': String(contain.invX),
            '--fit-contain-inv-y': String(contain.invY),
            '--fit-contain-uniform': String(contain.uniform),
          } as CSSProperties
        }
      >
        <FailDeliveryHeader />
        <PlaqueSmallBad />
        <CharacterIcon characterId={model.characterId} />
        <RestartButton
          onClick={controller.handleRestart}
          cost={model.restartCost}
          disabled={!model.canRestart}
        />
        <GoHomeButton onClick={controller.handleGoHome} />
      </div>
    </div>
  );
}
